import Error from '../components/shared/Error';

const ErrorPage = () => {
  return <Error />;
};

export default ErrorPage;
